import { render } from "./DeleteModule.vue?vue&type=template&id=7d4d320f"
import script from "./DeleteModule.vue?vue&type=script&lang=js"
export * from "./DeleteModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__